export const ApiUrls = {
    Lookup: {
        GetLookups: "Lookup/GetLookups",
        GetAdminLookup: "Lookups/GetLookups",
        AddLookup: "Lookup/AddLookup",
        EditLookup: "Lookup/EditLookup",
        DeleteLookup: "Lookup/DeleteLookup",
    },
    PNsFollowUpControler: {
        AddPNNoteFollowUp: 'PNsFollowUpControler/AddPNNoteFollowUp',
    },
    POSMachine: {
        SendCreditCardRequest: 'POSMachine/send-credit-card-request',
        GetTerminalProviderMachine: 'TerminalProviders/GetTerminalProviderMachine',
    },
    Treasury: {
        GetRefundedOrders: 'Treasury/GetRefundedOrders',
    },
    Regenerate: {
        RegenerateOrderOrigionalInvoiceServiceOrder: 'Cashier/RegenerateOrderOrigionalInvoiceServiceOrder',
        RegenerateOrigionalReceiptServiceOrder: 'Cashier/RegenerateOrigionalReceiptServiceOrder',
        RegenerateOrigionalReceiptDirectPayment: 'Cashier/RegenerateOrigionalReceiptDirectPayment',
        RegenerateOrigionalInvoiceSpareParts: 'Cashier/RegenerateOrigionalInvoiceSpareParts',
        RegenerateOrigionalReceiptSpareParts: 'Cashier/RegenerateOrigionalReceiptSpareParts',
        RegenerateORReceipt: 'Cashier/RegenerateORReceipt',
        RegenerateOrigionalReceiptCustomer: 'Cashier/RegenerateOrigionalReceiptCustomer',
        RegenerateCashierFullRefundOrder: 'DirectPaymentReturnOrder/RegenerateCashierFullRefundOrder',
        RegenerateCashierRefundServiceOrder: 'ServiceLayerReturnOrder/RegenerateCashierRefundServiceOrder',
        RegenerateSparePartReturnOrderInvoice: 'SparePartsReturnOrder/RegenerateSparePartReturnOrderInvoice',
    },
    User: {
        GetAccess: '/User/GetAccess',
        RefreshThirdPartyToken: '/User/RefreshThirdPartyToken',
        ClickPortal: "User/ClickPortal",
    },
}
